module.exports = __webpack_public_path__ + "img/mailbox2.a52e8072.svg";